import React, {  useContext, useState } from 'react'
import classNames from 'classnames'
import ImagesContext from 'app/react/components/images/ImagesContext'
import useFilter from 'app/react/components/images/useFilter'

export default function ImagesHeader () {

  const { setSearch, setCategories } = useFilter()
  const { headerTitle, headerText, texts, categories, isSearchLoading, setIsSearchLoading } = useContext(ImagesContext)

  const [activeTab, setActiveTab] = useState(0)

  const handleTabClick = (i) => {
    setActiveTab(i)
    setCategories(i)
  }

  return (
    <div className="header-with-filter">
      <div className="header-with-filter__inner">
        <div className="header-with-filter__filter-container">
          <div className="header-with-filter__title-container">
            {headerTitle && (
              <h2 className="header-with-filter__title dm-title">{headerTitle}</h2>
            )}
            <div className={classNames('header-with-filter__input', {
              'dm-show-input-loader': isSearchLoading
            })}>
              <input type="text" placeholder={texts.searchPlaceholder} className="dm-input" onChange={(e) => {
                setIsSearchLoading(true)
                setSearch(e)
              }} />
            </div>
          </div>
          {categories.length > 0 && (
            <>
              <div className="header-with-filter__tabs">
                {categories.map((tab, i) => {
                  return (
                    <div key={i} className={classNames('header-with-filter__tab', {
                      'header-with-filter__tab--active': parseInt(activeTab) === i
                    })} onClick={() => handleTabClick(i)}>{tab.name}</div>
                  )
                })}
              </div>
              <div className="header-with-filter__select select-container">
                <label>{texts.selectLabel}</label>
                <select value={activeTab} className="dm-select" onChange={(e) => handleTabClick(e.target.value)}>
                  {categories.map((cat, i) => {
                    return (
                      <option key={i} value={i}>{cat.name}</option>
                    )
                  })}
                </select>
              </div>
            </>
          )}
        </div>
        <div className="header-with-filter__text-container">
          {headerText && (
            <div className="header-with-filter__text dm-wysiwyg dm-wysiwyg--fs14 dm-wysiwyg--darkgrey" dangerouslySetInnerHTML={{ __html: headerText }} />
          )}
        </div>
      </div>
    </div>
  )
}
